const LABELS = {
  type: "Type",
  spec: "Spec",
  count: "Count",
  storage: "Storage",
  write: "Write requests",
  read: "Read requests",
  restore: "Backup restore",
  retrieval: "Retrieved",
  outbound: "Outbound traffic",
  betweenAZ: "Between AZ",
  commitment: "Bandwidth commitment",
  nlu: "NLUs",
  mbits: "WAF capacity",
  requests: "Requests",
  rules: "WAF rules",
  pro: "PRO",
  natGateways: "NAT gateways",
  users: "Users",
  zones: "Hosted zones",
  records: "Records per zone",
  queries: "Queries (M)",
  vms: "Managed VMs",
  vmPrice: "Avg. VM price",
  hosts: "Hosts",
  pods: "Pods",
  management: "Rancher installations",
  clusters: "Rancher clusters",
  downstream: "Downstream clusters",
  shared: "Shared instances",
  blockStorage: "Block storage (GB)",
  ipCount: "Public IPs",
  usageHours: "Hours per month",
  usagePercent: "Utilization (%)",
  dr: "DR backup",
  drAmount: "DR backup (GB)",
};

const formatValue = (value) => {
  if (typeof value === "boolean") return value ? "yes" : "no";
  if (typeof value === "number") return value.toLocaleString();
  return String(value);
};

/**
 * Human-readable one-liner for an estimate line. Lines carry their priced
 * items, so this is only the configuration echo used where items are not
 * shown (and for lines saved by older builds).
 */
export const generateConfigSummary = (line) => {
  if (!line) return "";

  if (line.items && line.items.length) {
    return line.items
      .map((item) => `${item.label}${item.detail ? ` (${item.detail})` : ""}`)
      .join("; ");
  }

  const config = line.config;

  if (!config || typeof config !== "object") {
    return config ? String(config) : line.description || "Standard configuration";
  }

  const parts = Object.entries(config)
    // `usageMode` only makes the hours/percent fields meaningful; skip the flag.
    .filter(([key, value]) => key !== "usageMode" && value !== null && value !== "" && value !== 0 && value !== false)
    .map(([key, value]) => {
      if (typeof value === "object") return null;
      return `${LABELS[key] || key}: ${formatValue(value)}`;
    })
    .filter(Boolean);

  return parts.length ? parts.join("; ") : line.description || "Standard configuration";
};
